import React from "react";
import {NavLink} from "react-router-dom";

function PageNavigationLink({label, route, ...rest}) {
    return (
        <li>
            <NavLink {...rest} to={route}><span>{label}</span></NavLink>
            <span className="trn"/>
        </li>
    );
}

export default PageNavigationLink;
